import { render } from "./robotIcon.vue?vue&type=template&id=9ac16e64&scoped=true"
import script from "./robotIcon.vue?vue&type=script&lang=js"
export * from "./robotIcon.vue?vue&type=script&lang=js"

import "./robotIcon.vue?vue&type=style&index=0&id=9ac16e64&scoped=true&lang=css"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ac16e64"]])

export default __exports__